import api, { unwrap } from './client';

// --- Admin (super-admin / admin) ---

export async function listAdminPayouts(params = {}) {
  return unwrap(await api.get('/admin/payouts', { params }));
}
export async function adminPayoutSummary() {
  return unwrap(await api.get('/admin/payouts/summary'));
}
export async function getAdminPayout(id) {
  return unwrap(await api.get(`/admin/payouts/${id}`));
}
export async function approvePayout(id, note = '') {
  return unwrap(await api.post(`/admin/payouts/${id}/approve`, { note }));
}
export async function releasePayout(id, note = '') {
  return unwrap(await api.post(`/admin/payouts/${id}/release`, { note }));
}
export async function rejectPayout(id, reason) {
  return unwrap(await api.post(`/admin/payouts/${id}/reject`, { reason }));
}
export async function syncPayoutStatus(id) {
  return unwrap(await api.post(`/admin/payouts/${id}/sync`));
}
export async function createPayoutForOrder(orderId) {
  return unwrap(await api.post(`/admin/payouts/order/${orderId}`));
}
export async function updateClinicPayoutSettings(clinicId, body) {
  return unwrap(await api.put(`/admin/clinics/${clinicId}/payout-settings`, body));
}
export async function curlecBalance() {
  return unwrap(await api.get('/admin/payouts/curlec/balance'));
}
export async function exportAdminPayoutsCsv(params = {}) {
  const res = await api.get('/admin/payouts/export.csv', { params, responseType: 'blob' });
  return res.data;
}

// --- Clinic (vendor) ---

export async function listMyPayouts(params = {}) {
  return unwrap(await api.get('/vendor/payouts', { params }));
}
export async function myPayoutSummary() {
  return unwrap(await api.get('/vendor/payouts/summary'));
}
export async function getMyPayout(id) {
  return unwrap(await api.get(`/vendor/payouts/${id}`));
}
export async function updateMyPayoutBank(body) {
  return unwrap(await api.put('/vendor/payout-settings', body));
}
export async function exportMyPayoutsCsv(params = {}) {
  const res = await api.get('/vendor/payouts/export.csv', { params, responseType: 'blob' });
  return res.data;
}
